/**
 * Notification events that can trigger notifications
 */

import { NotificationFlow } from "../validators/admin/settings-validators";

export type SystemNotificationEvent = "service_recover" | "service_down" | "service_up" | "embedding_finished" | "error_threshold_exceeded";

export const systemNotificationEvents = [
    "service_recover",
    "service_down",
    "service_up",
    "embedding_finished",
    "error_threshold_exceeded",
] as const

export const EVENT_LABELS: Record<string, { label: string; description: string }> = {
    service_recover: { label: "Service Recover", description: "Triggered when a service comes back online" },
    service_down: { label: "Service Down", description: "Triggered when a service becomes unavailable" },
    embedding_finished: { label: "Embedding Finished", description: "Triggered when document embedding completes" },
    error_threshold_exceeded: { label: "Error Threshold Exceeded", description: "Triggered when error rate is too high" },
};

export const DEFAULT_FLOWS: NotificationFlow[] = [
    {
        id: "1",
        name: "Service Down Alert",
        description: "Notify when critical services go down",
        event: "service_down",
        enabled: false,
        channels: {
            email: {
                enabled: true,
                recipients: [],
                subject: "🚨 Service Down Alert",
                template: "A critical service has gone down and requires attention.",
            },
            webhook: {
                enabled: true,
            },
        },
    },
    {
        id: "2",
        name: "Service Recover Alert",
        description: "Notify when critical services recover",
        event: "service_recover",
        enabled: false,
        channels: {
            email: {
                enabled: true,
                recipients: [],
                subject: "✅ Service Recover Alert",
                template: "A critical service has recovered and is back online.",
            },
            webhook: {
                enabled: true,
            },
        },

    },
    {
        id: "4",
        name: "Embedding Complete",
        description: "Notify when document embedding is finished",
        event: "embedding_finished",
        enabled: false,
        channels: {
            email: {
                enabled: true,
                recipients: [],
                subject: "✅ Embedding Process Complete",
                template: "Your document embedding process has finished successfully.",
            },
            webhook: {
                enabled: true,
            },
        },
    },
    {
        id: "5",
        name: "Error Threshold Exceeded",
        description: "Notify when error threshold is exceeded",
        event: "error_threshold_exceeded",
        enabled: false,
        channels: {
            email: {
                enabled: true,
                recipients: [],
                subject: "⚠️ Error Threshold Exceeded",
                template: "The system has exceeded the defined error threshold.",
            },
            webhook: {
                enabled: true,
            },
        }
    }
];